module.exports = __webpack_public_path__ + "img/notifications.e6fd84d7.svg";